<template>
	<o-select
		v-bind="$attrs"
		v-model="setup.userId"
		class="shared-select-assignee"
		label="Assigner à"
		:options="options"
		track-key="id"
		value-key="id"
		display-key="name">
		<template #value="{ item }">
			<span
				v-if="item"
				class="shared-select-assignee__selected">
				<o-avatar
					size="xs"
					:name="item.name"
					:avatar="item.avatarId"
					root-url="/app/avatar/"/>
				{{ item.name }}
			</span>
		</template>

		<template #option="{ item }">
			<div class="shared-select-assignee__item">
				<o-avatar
					class="shared-select-assignee__avatar"
					size="xs"
					:name="item.name"
					:avatar="item.avatarId"
					root-url="/app/avatar/"/>
				<div class="shared-select-assignee__text">
					<div class="shared-select-assignee__name">
						{{ item.name }}
						<o-label
							v-if="item.id === setup.self.id"
							size="sm">
							Moi
						</o-label>
					</div>
					<small class="shared-select-assignee__mail">{{ item.authLogin }}</small>
				</div>
			</div>
		</template>
	</o-select>
</template>

<script setup lang="ts">
import SharedSelectAssigneeSetupService from '@/setup/shared/SharedSelectAssigneeSetupService';
const emits = defineEmits<{(e: 'update:modelValue' | 'input', val: Undef<number>): void}>();
const props = defineProps(SharedSelectAssigneeSetupService.props);
const setup = new SharedSelectAssigneeSetupService(props, emits);
</script>

<style scoped lang="less">
@import '@/styles/mixins.less';

.shared-select-assignee {
	&__item {
		display: flex;
		align-items: center;
		gap: 10px;
		width: 100%;
		padding: 5px 0;
	}

	&__text {
		flex: 1;
	}

	&__name {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 15px;
		font-weight: 600;
		color: var(--grey-darker);

		.selected & {
			color: white;
		}
	}

	&__mail {
		color: var(--grey-dark);

		.selected & {
			color: white;
		}
	}

	&__selected {
		display: flex;
		gap: 10px;

		:deep(.orion-avatar) {
      .circle(1.25rem);
		}
	}
}
</style>
